<template>
	<div class="container__cardgrafico">
		<div class="container__cardgrafico__top">
			<div class="container__cardgrafico__top__info">
				<label class="container__cardgrafico__top__info__title">{{ title }}</label>
				<label class="container__cardgrafico__top__info__subtitle">{{ subtitle }}</label>
			</div>
			<div class="container__cardgrafico__top__buttons">
				<slot name="botoes" />
			</div>
		</div>
		<div class="container__cardgrafico__body">
			<slot name="grafico" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		subtitle: String,
	},
}
</script>

<style scoped>
.container__cardgrafico {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: auto;
	padding: 1rem 2rem;
}

.container__cardgrafico__top {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: space-between;
	align-items: center;
}

.container__cardgrafico__top__info {
	display: flex;
	flex-direction: column;
	text-align: center;
}

.container__cardgrafico__top__info__title {
	color: rgb(var(--color-primary));
	font-weight: 700;
}

.container__cardgrafico__top__info__subtitle {
	color: var(--color-gray);
	font-size: 0.75rem;
}

.container__cardgrafico__top__buttons {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.container__cardgrafico__body {
	margin: 1rem 0;
	width: 100%;
	height: 100%;
}

@media screen and (min-width: 992px) {
	.container__cardgrafico__top {
		flex-direction: row;
	}
	.container__cardgrafico__top__info {
		text-align: unset;
	}

	.container__cardgrafico__top__buttons {
		width: unset;
	}
}
</style>
